import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { ImgSliderModule } from './img-slider/img-slider.module';
import { IntroSectionModule } from './intro-section/intro-section.module';

@NgModule({
  imports: [
    CommonModule,
    ImgSliderModule,
    IntroSectionModule
  ],
  declarations: [
    HomeComponent
  ],
  exports: [
    HomeComponent
  ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/pages/home/home.module.ts